module.exports = __webpack_public_path__ + "static/media/RPI_RPI-Logo.89389330.png";